// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"7f228dad","156":"8ccc77c2","213":"941650df","385":"8139831f","422":"85c83aeb","500":"8a18fe80","677":"7f2de68d","849":"ddbe5050"}[chunkId] + ".chunk.js";
};